<ng-container *ngIf="initStatus === appInitStatus.LOAD; else siteContent">
  <div
    @inOutLoader
    class="d-flex justify-content-center align-items-center h-100 transition"
  >
    <ng-lottie [options]="spinnerOptions"></ng-lottie>
  </div>
</ng-container>
<ng-template #siteContent>
  <div class="site-content" @inOutContent>
    <ng-container *ngIf="layout === 'fullscreenLayout'; else defaultLayout">
      <router-outlet></router-outlet>
    </ng-container>
    <ng-template #defaultLayout>
      <div class="container-default">
        <app-header-login></app-header-login>
        <main class="outer">
          <div class="container-fluid h-100">
            <div class="row align-items-stretch h-100">
              <div
                class="col-6 container-default__illustration d-none d-lg-flex align-items-center center-content text-center h-100"
              >
                <ng-lottie [options]="options" class="flex-fill"></ng-lottie>
              </div>
              <div
                class="col-12 col-lg-6 container-default__content center-content h-100"
              >
                <div class="mh-100 overflow-auto w-100">
                  <div class="m-auto">
                    <router-outlet></router-outlet>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-6 container-default__legal-notice fw-medium w-100 w-lg-50 footer-resp"
            >
              <div class="container-fluid text-center">
                &copy; Ad Scientiam 2013 - {{ now | date : "Y" }} |
                <span i18n="@@common_footer_right">Tous droits réservés</span>
                |
                <span>version </span>
                {{ version }}
              </div>
            </div>
          </div>
          <div class="footer-resp-legal pb-2">
            <div class="container-fluid text-center">
              &copy; Ad Scientiam 2013 - {{ now | date : "Y" }} |
              <span i18n="@@common_footer_right">Tous droits réservés</span>
              |
              <span>version </span>
              {{ version }}
            </div>
          </div>
        </main>
      </div>
    </ng-template>
  </div>
</ng-template>
<app-spinner></app-spinner>
